// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"84125339","484":"c924037d","498":"bf7702b5","551":"4628e233","828":"49b10d6f","851":"7c75998c"}[chunkId] + ".chunk.js";
};